/* @flow */
import startCase from 'lodash/startCase';

function parseServerErrors(errors): Array<string | Object> {
  if (typeof errors === 'string') {
    return [errors];
  } else if (Array.isArray(errors)) {
    return errors;
  }
  return Object.keys(errors).map((key) => {
    let errorKey: any = [startCase(key.replace(/_/g, ' '))];
    return `${errorKey}: ${errors[key].toString()}`;
  });
}

export default function defineServerErrors(payload: Object, defaultMessage: string) {
  const errorsPayload = payload.response?.data ?? defaultMessage;
  const errorsStatus = payload.response?.status ?? 0;
  if (errorsStatus >= 401 && errorsStatus < 500) {
    let error;
    switch (errorsStatus) {
      case 401:
        error = '401: Unauthorized. Request denied.';
        break;
      case 403:
        error = "403: You don't have permission to access this request on this server";
        break;
      case 404:
        error = '404: The requested resource was not found on this server.';
        break;
      case 405:
        error = '405: Request is not allowed.';
        break;
      default:
        error = 'Some error has occurred. Please try again later.';
    }
    return [error];
  } else {
    return parseServerErrors(errorsPayload);
  }
}
